import { FC, useState } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'

import { EmailPassFormInputs } from '../../../types/EmailPassFormInputs'
import Button from '../../../common/components/Button'
import styles from './SignUpForm.module.css'
import EmailInput from '../../../common/components/Auth/EmailInput'
import PasswordInput from '../../../common/components/Auth/PasswordInput'
import ConfirmPasswordInput from '../../../common/components/Auth/ConfirmPasswordInput'
import { t } from 'i18next'
import TermsModal from '../TermsModal'

interface SignUpFormProps {}

const SignUpForm: FC<SignUpFormProps> = () => {
  const navigate = useNavigate()
  const [apiError, setApiError] = useState<string>('')
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<any>()

  const handleOnTermsClick = () => {
    setIsModalOpen(true)
  }

  const onTermsAcceptClick = () => {
    setIsModalOpen(false)
    setValue('checkbox', true)
  }

  const onSubmit: SubmitHandler<EmailPassFormInputs> = async (data) => {
    const systemLanguage = localStorage.getItem('i18nextLng')?.split('-').at(0)

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/register`,
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json; charset=utf-8',
        }),
        body: JSON.stringify({
          email: data.email.toLowerCase(),
          password: data.password,
          language: systemLanguage || 'en',
        }),
      },
    )

    if (response.ok) {
      mixpanel.track('Signup Success')
      localStorage.setItem('email', data.email)
      navigate('/activation')
    } else {
      const { message } = await response.json()
      setApiError(message)
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className={styles.formContainer}>
        <EmailInput register={register} errors={errors} />
        <PasswordInput name="password" register={register} errors={errors} />
        <ConfirmPasswordInput
          name="confirmPassword"
          register={register}
          errors={errors}
        />
        <div>
          <p>
            <em>{t('signup.passwordComplexity')}</em>
          </p>
        </div>
        <div className={styles.checkboxContainer}>
          <input
            type="checkbox"
            {...register('checkbox', { required: true })}
            id="html"
          />
          <label htmlFor="html" />
          <div className={styles.terms}>
            * {t('signup.iAccept')}
            <p onClick={handleOnTermsClick}>{t('signup.terms')}</p>
          </div>
        </div>

        <div className={styles.errors}>{apiError}</div>

        <Button title={t('login.signUp')} />
      </form>
      {isModalOpen && (
        <TermsModal
          onAccept={onTermsAcceptClick}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  )
}

export default SignUpForm
